import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../services/api';
import Navbar from '../shared/Navbar';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setMessage(null);
    setLoading(true);
    try {
      const result = await api.forgotPassword(email);
      setMessage(result.message);
    } catch (caught: any) {
      setError(caught?.message || 'Failed to request a password reset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <Navbar />
      <main className="app-main">
        <div className="content-container auth-container">
          <div className="tm-surface auth-card">
            <h2 className="auth-title">Forgot Password</h2>
            <p className="auth-subtitle">
              Enter your email and we’ll send you a reset link.
            </p>
            <form onSubmit={onSubmit} className="login-form">
              <div className="form-row">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </div>
              {error && <div className="ml-error">{error}</div>}
              {message && <div className="auth-subtitle">{message}</div>}
              <button
                type="submit"
                className="tm-button tm-button--primary ml-replace-btn auth-submit"
                disabled={loading}
              >
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
              <div className="auth-links">
                <Link to="/login">Back to sign in</Link>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ForgotPasswordPage;
